import { render, staticRenderFns } from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=template&id=98b99d74&scoped=true"
import script from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=script&lang=js"
export * from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=script&lang=js"
import style0 from "./UsabilidadeDoSistemaCoordenadorPage.vue?vue&type=style&index=0&id=98b99d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b99d74",
  null
  
)

export default component.exports